<div class="condition-wrapper" (click)="log(condition)" [hidden]="!condition?.variables?.length">
		<!-- [formGroup]="condition.expression" -->
	<ie-form-field [label]="'IF'" [warningMessage]="expressionInvalid ? ('INVALID_EXPRESSION' | translate) : ''">
		<input type="text" class="ie-form-field-styling"
			#expressionInput [(ngModel)]="condition.expression" (ngModelChange)="expressionChange($event)" (change)="expressionChanged($event)" 
			(keyup)="onKeyUp($event)" />
	</ie-form-field>

	<div class="expression-buttons">
		<ng-container *ngFor="let button of buttonGroup">
			<button class="operator" (click)="addExpressionPart(button.value)">{{button.label}}</button>
		</ng-container>
	</div>
</div>
<div *ngIf="condition && condition.variables" class="condition-variable-wrapper">
	<condition-variable 
		*ngFor="let variable of condition.variables; trackBy: trackBy"
		[conditionVariable]="variable"
		(delete)="removeConditionVariable($event)"
		(conditionVariableChanged)="conditionVariableChanged($event)">
	</condition-variable>
</div>
<div class="add-condition">
	<div class="add-condition-plus"><i class="fa fa-plus"></i></div>
	<span class="add-condition-label">add <span class="add-condition-variable">variable</span> condition</span>
</div>
<div class="icon-group">
	<bb-icon-list [options]="optionList" [actionOnly]="true" (selected)="addConditionVariable($event)"></bb-icon-list>
</div>
